const loadScriptAsync = (url: string, callback: () => void) => {
  const selector = 'script';
  const el = document.createElement(selector);
  const script = document.getElementsByTagName(selector)[0];
  el.src = url;

  if (callback) {
    el.addEventListener('load', () => callback(), false);
  }
  script.parentNode?.insertBefore(el, script);
};

export default loadScriptAsync;
